import React from 'react';
import { UseQueryResult } from '@tanstack/react-query';
import { Loader } from './Loader';
import { Error } from './Error';

interface QueryBoundaryProps<TData, TError> {
  query: Pick<UseQueryResult<TData, TError>, "isLoading" | "isError" | "refetch">;
  errorMessage?: string;
  children: React.ReactNode;
}

/**
 * QueryBoundary Component
 * 
 * Generic component for handling React Query states (loading, error, success)
 * Shows loader while loading, error with retry button on error, and renders children on success.
 */
export function QueryBoundary<TData, TError>({ 
  query, 
  errorMessage = 'Something went wrong', 
  children 
}: QueryBoundaryProps<TData, TError>) {
  if (query.isLoading) {
    return <Loader />;
  }

  if (query.isError) {
    return (
      <Error 
        message={errorMessage} 
        onRetry={() => query.refetch()} 
      />
    );
  }

  return <>{children}</>;
}
